// Taze manav (günlük fiyatı değişen) kategori tespiti — backend product_naming.py
// FRESH_PRODUCE_CATEGORIES ile eşdeğer tutulur (drift'i önlemek için tek kaynak).
export const FRESH_PRODUCE_CATEGORIES = new Set([
  "taze", "meyve", "sebze", "yeşillik", "yesillik", "tropikal", "manav",
  "meyve & sebze", "meyve&sebze", "meyve sebze",
]);

export function isFreshProduce(category) {
  const c = (category || "").trim().toLowerCase();
  if (!c) return false;
  return FRESH_PRODUCE_CATEGORIES.has(c) || c.includes("manav");
}
